// extracted by mini-css-extract-plugin
module.exports = {"overlay":"GoatContentModal_overlay__1UZW1","modal":"GoatContentModal_modal__2gs-C","btn-close":"GoatContentModal_btn-close__1I5V7"};